var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-dialog-full',{ref:"refBaseDialogFull",attrs:{"show":true,"tempSaveBtn":_vm.isTempSaveBtn,"title":_vm.title},on:{"close":_vm.closeHandler,"save":_vm.saveHandler}},[_c('router-view',{ref:"refProposalTabs",on:{"go-top":_vm.goTop,"set-title":_vm.setTitle,"temp-btn-hide":_vm.tempBtnHide}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }